module.exports = __webpack_public_path__ + "img/Adam.b2b421e6.png";